import { render, staticRenderFns } from "./CreateAttendanceKidCustomExcelV2.vue?vue&type=template&id=525a5a22&scoped=true"
import script from "./CreateAttendanceKidCustomExcelV2.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceKidCustomExcelV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a5a22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525a5a22')) {
      api.createRecord('525a5a22', component.options)
    } else {
      api.reload('525a5a22', component.options)
    }
    module.hot.accept("./CreateAttendanceKidCustomExcelV2.vue?vue&type=template&id=525a5a22&scoped=true", function () {
      api.rerender('525a5a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateAttendanceKidCustomExcelV2.vue"
export default component.exports